import React, { Component } from 'react';
import {
  Section,
  Title,
  Body,
  SectionGrid,
} from './Section';
// icons
import IconSetup from 'react-icons/lib/fa/cogs';
import IconBuilding from 'react-icons/lib/fa/building-o';

import './Landing.css';

class HowItWorks extends Component {
  render() {
    return (
      <Section sStyle="purple">
        <Title title="HOW" subtitle="IT WORKS." />
        <Body>
          <p>Quick and easy setup with no hardware required!</p>
          <p>Your intercom is compatible if it can call a mobile or a landline phone.</p>
        </Body>
        <SectionGrid responsive={false} items={[
          { title: "SET UP",
            icon: <IconSetup />,
            text: (
              <ol>
                <li>Sign up to get a Passcode number</li>
                <li>Give the Passcode number to your building manager as your intercom number</li>
                <li>Add and share passcodes with your guests</li>
              </ol>
            )},
          { title: "USE",
            icon: <IconBuilding />,
            text: (
              <ol>
                <li>When entering your building, key in your buzzer number as usual</li>
                <li>When the call connects, key in a passcode that you've already setup</li>
                <li>The door will unlock shortly if the passcode is correct!</li>
              </ol>
            )}
        ]} />
      </Section>
    );
  }
}

export default HowItWorks


// WEBPACK FOOTER //
// ./src/entries/Static/HowItWorks.js